import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    
    // Only add scroll listener if header has hide-header class (homepage)
    if (this.element.classList.contains('hide-header')) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const scrolled = window.scrollY > 100

    if (scrolled) {
      this.element.classList.remove('header-hidden')
      this.element.classList.add('header-visible')
    } else {
      this.element.classList.remove('header-visible')
      this.element.classList.add('header-hidden')
    }
  }
}

